import React from "react";
import "./ServicePages.scss";

//Panels
import Hero from "./Components/Hero";

//Images
import driveways from "./images/driveways/bg-driveways.jpg";
import featureA1 from "./images/driveways/feature-a-1.jpg";
import featureA2 from "./images/driveways/feature-a-2.jpg";
import featureA3 from "./images/driveways/feature-a-3.jpg";
import featureB1 from "./images/driveways/BEL2017_Coastal_SWATCH_HollandStone_Knightsbridge.jpg";
import featureB2 from "./images/driveways/Heartland-Paver-Sand-Stone-Mocha.jpg";
import featureB3 from "./images/driveways/permeable-aqualina-dark-grey-pewter.jpg";

//SEO
import SEO from "../../../SEO/index.js";
import StructuredData from "../../../SEO/structuredData";

const Driveways = () => {
  return (
    <>
      <SEO
        title="Paver Driveway Installation | Los Angeles | Pacific Pavingstone"
        description="Enhance your home's entrance with a durable paving stone driveway from Pacific Pavingstone, the premier pavingstone installers in Southern California."
        profileURL={"https://www.pacificpavingstone.com/services/driveways"}
        type="website"
      />
      <StructuredData
        orgaCreator={{
          "@context": "https://schema.org/",
          "@type": "Service",
          name: "Paver Driveway Installation",
          image:
            "https://www.pacificpavingstone.com/static/media/bg-driveways.ca2ccd8c.jpg",
          description:
            "Enhance your home's entrance with a durable paving stone driveway from Pacific Pavingstone, the premier pavingstone installers in Southern California.",
          brand: "Pacific Pavingstone",
          areaServed: "Southern California",
          logo: "https://www.pacificpavingstone.com/static/media/logo-2.bf1f43f9.png",
          provider: "Pacific Pavingstone",
          URL: "https://www.pacificpavingstone.com/services/driveways",
          potentialAction: "Schedule a Consultation",
          aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: "5",
            bestRating: "5",
            worstRating: "1",
            ratingCount: "1",
            reviewCount: "1",
          },
          review: {
            "@type": "Review",
            name: "S.L.",
            reviewBody:
              "This company is one of the best and most ethical company I have ever worked with. I have had extensive remodeling at my house. No one I mean no one has ever been more responsible and punctual. They finished my driveway a week ahead of schedule. I'm very impressed. Even after the job was done they contacted me and wanted to make sure we were happy. The crew and supervisorCraig Jorge Onicemo, Hugo and Javier are all fantastic and professional group. Trust me if need any work done these guys are very legit and impressive. You would not regret it. Their work is very clean and design is amazing. Thank you Pacific paving Stone, GREAT JOB",
            reviewRating: {
              "@type": "Rating",
              ratingValue: "5",
              bestRating: "5",
              worstRating: "1",
            },
            datePublished: "2021-10-08",
            author: { "@type": "Person", name: "S.L." },
            publisher: { "@type": "Organization", name: "Pacific Pavingstone" },
          },
        }}
      />
      <div className="container-fluid page-featured">
        <Hero title={"Driveways"} background={driveways} />
        <div className="row justify-content-center">
          <div className="col-11 col-md-9">
            <div className="row justify-content-center panel-content">
              <div className="col-12">
                <h2 className="text-center text-uppercase mb-4">Driveways</h2>
                <p>
                  When choosing a driveway material, the most crucial aspect to
                  consider is durability. You need material that can withstand
                  tons of pressure and live up to every day use. In that regard,
                  paving stones are unmatched.
                  <br />
                  <br />
                  Because of their unique shape and the way they are installed,
                  paving stones offer a flexibility that is envied by other
                  driveway materials.
                  <br />
                  <br />
                  Unlike concrete, paving stones do not crack in harsh weather
                  or under pressure. They do not get faded or discolored. If a
                  problem should arise in your driveway (I.e. an oil spill on
                  pavers or other stain), instead of replacing the entire
                  driveway for tens of thousands of dollars you can replace just
                  the affected stones for substantially cheaper.
                  <br />
                  <br />
                  Sealing your driveway with paver sealer is also a great way to
                  protect your investment even further. Paver sealer coats your
                  driveway and wards off stains and maintains the original color
                  of your stone.
                  <br />
                  <br />
                  Paving stones are also a great material if you want to add a
                  flare to your outdoor space. Because of their versatility in
                  size, shape and color, pavers can be laid in intricate
                  patterns that allow you to make any shape or design you’d
                  like.
                  <br />
                  <br />
                  If the environment is something that is important to you, you
                  can also try permeable pavers. Permeable pavers are
                  interlocking paving stones that are installed on top of
                  various of layers and aquifers that store rain runoff. This
                  prevents stormwater pooling on your driveway or damaging your
                  home’s infrastructure. Permeable pavers are also eco-friendly
                  as they divert stormwater runoff from the main city drainage
                  system.
                  <br />
                  <br />
                  Paving stones also need very minimal maintenance as opposed to
                  concrete driveways and can last an average of 30 to 50 years
                  (twice as long as concrete). When compared side by side, a
                  Paving stone driveway is more economical, eco-friendly, more
                  durable and more aesthetically pleasing than it’s concrete
                  counterpart.
                </p>
              </div>
              <div className="col-12 mt-5">
                <div className="row justify-content-center">
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureA1}
                      alt="Featured"
                    />
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureA2}
                      alt="Featured"
                    />
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureA3}
                      alt="Featured"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row justify-content-center panel-content">
              <div className="col-12 mt-4">
                <div className="row justify-content-center">
                  <div className="col-12 col-md-8 col-lg-4">
                    <div className="image-style mb-2 mb-lg-0">
                      <img
                        src={featureB1}
                        alt="Belgard Holland Stone In Knightsbridge"
                      />
                      <div className="text">
                        <p>
                          Belgard Holland Stone
                          <br />
                          In Knightsbridge
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <div className="image-style mb-2 mb-lg-0">
                      <img
                        src={featureB2}
                        alt="
                          Angelus Heartland Paver In Sand Stone Mocha"
                      />
                      <div className="text">
                        <p>
                          Angelus Heartland Paver
                          <br />
                          In Sand Stone Mocha
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <div className="image-style mb-2 mb-lg-0">
                      <img
                        src={featureB3}
                        alt="
                          Angelus Permeable Aqualina In Dark Grey-Pewter"
                      />
                      <div className="text">
                        <p>
                          Angelus Permeable Aqualina
                          <br />
                          In Dark Grey-Pewter
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Driveways;
